import { MARQUEE_ITEMS } from "../../data/site";

export const Marquee = () => (
  <div
    data-testid="editorial-marquee"
    className="relative overflow-hidden border-y border-white/5 bg-paper py-5"
  >
    <div className="marquee-track flex w-max items-center gap-10 whitespace-nowrap">
      {[0, 1].map((dup) => (
        <div key={dup} className="flex items-center gap-10" aria-hidden={dup === 1}>
          {MARQUEE_ITEMS.map((item) => (
            <span key={`${dup}-${item}`} className="flex items-center gap-10">
              <span className="font-display text-sm font-semibold uppercase tracking-[0.2em] text-ink/70">
                {item}
              </span>
              <span className="h-1.5 w-1.5 rounded-full bg-champagne" />
            </span>
          ))}
        </div>
      ))}
    </div>
  </div>
);
